import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { GesturesModule } from "../gestures/gestures.module";
import { ToastComponent } from "./components/toast/toast.component";
import { ToastsWrapperComponent } from "./components/toasts-wrapper/toasts-wrapper.component";

@NgModule({
	declarations: [ToastsWrapperComponent, ToastComponent],
	exports: [ToastsWrapperComponent, ToastComponent],
	imports: [CommonModule, IonicModule, GesturesModule]
})
export class ToastModule {}
